export default{
  items: [],
  services: [],
  countPages: 0,
  current_page: 0,
  page_size: 10,
  totalElements: 0,
  totalPages: 1,
  email: '',
  search_message: '',
  loadingClear: false,
  requestURI: '',
  allowed_to_cancel: [],
  dateSend: '',
  logsToEdit: {
    previewMainImage: '',
    previewMainIcon: '',
    previewMainIconButton: '',
    previewMainIconButton2: '',
    title: '',
    message: '',
    url: '',
    file: '',
    image: null,
    imageUrl: null,
    icon: null,
    iconUrl: null,
    date: null,
    durationTime: '01:00',
    hour: '00:00',
    button1: {
      id: '1',
      text: null,
      icon: null,
      url: null
    },
    button2: {
      id: '2',
      text: null,
      icon: null,
      url: null
    },
    iconButton1: null,
    iconButton1Url: null,
    iconButton2: null,
    iconButton2Url: null,
    timeToLiveSeconds: null,
  },
  // teste
  params: '',
  idUser: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/push_web_logs/state.js